<template>
  <div class="matrix-cards-container">

    <div v-for="(s, index) in statusesStats()" :key="index" class="link black card">
      <div class="flex flex-row">
        <h1 class="db ma0 pa0 f6 fw4 ttu">{{ s.title }}</h1>
        <span class="ml3 db f6">{{ s.total }}</span>
      </div>

      <div class="mv3">
        <hr class="hr-circle">
      </div>

      <div class="entities-statutes-stats">
        <template v-for="(stat, index) in s.stats">
          <template v-if="stat.count > 0">
            <div :key="index" class="pointer lh-copy black underline" @click="routeByStatus(stat, s)">
              {{ stat.name }}
            </div>
            <div :key="1000 + index">
              {{ stat.count }}
            </div>
          </template>
        </template>
      </div>
    </div>

    <div v-for="(s, index) in companiesStats()" :key="10000 + index" class="lh-copy black card">
      <div class="flex flex-row">
        <span class="f6"><font-awesome-icon :icon="['far', 'building']" class="mr2"/></span>
        <h1 class="db ma0 pa0 f6 fw4 ttu">{{ s.title }}</h1>
        <span class="ml3 db f6">{{ s.stats.length }}</span>
      </div>

      <div class="mv3">
        <hr class="hr-circle">
      </div>

      <div class="entities-statutes-stats">
        <template v-for="(stat, index) in s.stats">
          <template v-if="stat.count > 0">
            <div :key="index" class="pointer black underline" @click="routeByComany(stat, s)">
              {{ stat.name }}
            </div>
            <div :key="1000 + index" class="">
              {{ stat.count }}
            </div>
          </template>
        </template>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: [
    'incoming',
    'outcoming'
  ],
  methods: {
    statusesStats () {
      return [{
        title: 'Исходящие',
        total: this.$store.getters[this.outcoming.module + '/' + this.outcoming.items].length,
        stats: this.$store.getters[this.outcoming.module + '/statusesStats'],
        route: this.outcoming.route,
        store: this.outcoming.module
      },
      {
        title: 'Входящие',
        total: this.$store.getters[this.incoming.module + '/' + this.incoming.items].length,
        stats: this.$store.getters[this.incoming.module + '/statusesStats'],
        route: this.incoming.route,
        store: this.incoming.module
      }]
    },
    companiesStats () {
      return [{
        title: 'Контрагенты',
        stats: this.$store.getters[this.outcoming.module + '/companiesStats'],
        route: this.outcoming.route,
        store: this.outcoming.module
      }, {
        title: 'Организаторы',
        stats: this.$store.getters[this.incoming.module + '/companiesStats'],
        route: this.incoming.route,
        store: this.incoming.module
      }]
    },
    routeByStatus (status, stat) {
      this.$store.dispatch(stat.store + '/filter/reset')
      this.$store.dispatch(stat.store + '/filter/setStatus', [status.id])
      this.$router.push({ name: stat.route })
    },
    routeByComany (company, stat) {
      this.$store.dispatch(stat.store + '/filter/reset')
      this.$store.dispatch(stat.store + '/filter/setCompany', company.id)
      this.$router.push({ name: stat.route })
    }
  }
}
</script>

<style lang="scss" scoped>
.entities-statutes-stats {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto;
  grid-column-gap: 0rem;
  grid-row-gap: .7rem;
  align-items: end;
}
</style>
